import {useMutation} from "react-query";
import apis from "services";
import {get} from "lodash";

export default function useFetchMembers() {

    const {
        mutate: fetchMembers,
        data: memberResponse,
        isLoading: fetchingMembers,
        isSuccess: membersFetched
    } = useMutation('members', apis.membersApi);

    const members = get(memberResponse, 'data.rows', []);

    return [fetchMembers, members, fetchingMembers, membersFetched]
}